import { api } from "../lib/axios";

import type { VectorEmbeddingModel } from "../types/vector";
import type { ApiData } from "./apiData";

interface DeleteVectorMetadatasBody {
    filesIds: Array<string>
    metadatas: Array<{ name: string }>
    embeddingModelName: VectorEmbeddingModel
}

interface DeleteVectorMetadatasData {
    message: string
}

async function deleteVectorMetadatas(body: DeleteVectorMetadatasBody) {
    const response = await api.delete<ApiData<DeleteVectorMetadatasData>>(
        '/vector/metadata/delete',
        { data: body }
    )

    return response.data
}

export { deleteVectorMetadatas, type DeleteVectorMetadatasBody }